var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photoToolbar" }, [
    _c("div", { staticClass: "navButtons" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.internalChannelId,
              expression: "internalChannelId",
            },
          ],
          staticClass: "backButton",
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.onBackButtonClick.apply(null, arguments)
            },
          },
        },
        [_vm._m(0), _c("span", [_vm._v(_vm._s(_vm.$t("buttonBack")))])]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.internalChannelId,
              expression: "!internalChannelId",
            },
          ],
        },
        [_vm._v(" ")]
      ),
      _c(
        "button",
        {
          staticClass: "closeButton",
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.onCloseButtonClick.apply(null, arguments)
            },
          },
        },
        [_vm._m(1), _c("span", [_vm._v(_vm._s(_vm.$t("buttonClose")))])]
      ),
    ]),
    _c(
      "div",
      { staticClass: "componentView" },
      [
        _vm.isVisible && _vm.internalChannelId
          ? _c("CloudSelectorView", {
              attrs: {
                "import-mode": _vm.importMode,
                "toolbar-mode": true,
                source: _vm.internalChannelId,
              },
              on: {
                increaseLevel: _vm.onIncreaseLevel,
                resetLevel: _vm.onResetLevel,
                selectPhoto: _vm.onPhotoSelect,
                importPhotos: _vm.onCloseButtonClick,
              },
            })
          : _vm.isVisible && _vm.internalActiveView === "library"
          ? _c("ImportLibraryView", {
              attrs: {
                "page-objects": _vm.pageObjects,
                "product-photos": _vm.productPhotos,
              },
              on: {
                addMorePhotos: _vm.onAddMorePhotosClick,
                clickItem: _vm.onLibraryViewItemClick,
              },
            })
          : _vm.isVisible && _vm.internalActiveView === "channels"
          ? _c("ImportSelectView", {
              attrs: { "show-skip-button": false },
              on: { clickChannel: _vm.onChannelClick },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "backButtonIcon" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("keyboard_arrow_left"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "closeButtonIcon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("expand_more")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }